import { Button, Flex, Input } from "antd";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import AllocationFilter from "../../Reuseable/Allocation/AllocationFilter/AllocationFilter";
import CustomFilterDropdown from "../../Reuseable/Allocation/CustomFilterDropdown/CustomFilterDropdown";
import Tabs from "../../Reuseable/Tabs/Tabs";
import { ReactComponent as SearchICon } from "../../assets/Icons/SearchIcon.svg";
import AllCases from "../../components/AllocationComp/AllCases/AllCases";
import AllocateModal from "../../components/AllocationComp/AllocateModal/AllocateModal";
import UserWiseList from "../../components/AllocationComp/UserWiseList/UserWiseList";
import {
  fetchAllocatedCase,
  fetchAllocationUsersWise,
  fetchUnAllocatedCase,
} from "../../store/allocationSlice";
import { clearQuery, fetchUserFilters, setQuery } from "../../store/filters";
import { fetchBankDashboard } from "../../store/portfolioSlice";
import { fetchTelecallerAllocatedCase } from "../../store/telecaller/cases";
import { fetchTelecallerBankDashboard } from "../../store/telecaller/telecallerDashboard";
import "./AllocationPage.scss";
import { clearUserList } from "../../store/agencySlice";
import { getUserType } from "../../assets/helpers";
import ExportModal from "../../components/AllocationComp/ExportModal/ExportModal";

const AllocationPage = () => {
  const location = useLocation();
  const [isReady, setIsReady] = useState(false);
  const [selectedTab, setSelectedTab] = useState("Allocated");
  const [selectedPortfolio, setSelectedPortfolio] = useState("all");
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [portfolioResetKey, setPortfolioResetKey] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const [allocateModalOpen, setAllocateModalOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [isAll, setIsAll] = useState(false);
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [params, setParams] = useState({
    page: 1,
    page_size: 10,
  });
  const isUserWise = location.pathname === "/allocation/user-wise";
  const isCases = location.pathname === "/allocation/cases";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    user_wise_list,
    user_wise_loading,
    unAllocated_case,
    unAllocated_case_loading,
    allocated_case,
    allocated_case_loading,
  } = useSelector((state) => state.allocation);
  const { bankDashboard = [], bankDashboard_loading } = useSelector(
    (state) => state?.portfolio,
  );
  const { query, filter_list } = useSelector((state) => state.filters);
  const { user } = useSelector((state) => state.auth);
  const { telecaller_cases, telecaller_cases_loading } = useSelector(
    (state) => state.telecallerCases,
  );
  const { tele_bank_dashboard_loading, tele_bank_dashboard } = useSelector(
    (state) => state.telecallerDashboard,
  );
  console.log(tele_bank_dashboard, "tele_bank_dashboard");

  /* No "All" entry: the filter chip carries a cross to clear the selection,
     so an explicit reset option is redundant. */
  const buildPortfolios = (data = []) =>
    data.map(({ name, id }) => ({
      label: name,
      value: id,
    }));

  const telePortfolios = buildPortfolios(tele_bank_dashboard);
  const portfoliosData = filter_list?.find((item) => item?.name === "portfolios")?.filters || [];
  const portfolios = buildPortfolios(portfoliosData);

  const filters = [
    { label: "Supervisor", value: "supervisor" },
    { label: "Team Lead", value: "teamlead" },
    { label: "Telecaller", value: "telecaller" },
    { label: "Field Agent", value: "fieldagent" },
  ];

  const handleAllocate = () => {
    if (isAll && !params?.portfolio) {
      toast.error("Please Select Portfolio");
      return;
    }
    setAllocateModalOpen(true);
    dispatch(clearUserList());
  };

  const tabOptions = [
    { label: "Allocated", value: "Allocated" },
    ...(getUserType(user) !== "supervisor"
      ? [{ label: "Unallocated", value: "Unallocated" }]
      : []),
  ];

  const handleRowClick = (record) => {
    navigate(`/allocation/cases/customer-details/${record?.customer_name}`, {
      state: record,
    });
  };
  const handleClick = (record) => {
    navigate(`/allocation/user-wise/employee-details/${record?.id}`);
  };

  console.log("query", query);

  useEffect(() => {
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(
        ([_, v]) => v !== undefined && v !== "" && v !== "all",
      ),
    );
    if (!isReady) return;
    const isTelecaller = getUserType(user) === "telecaller";
    if (isUserWise && !isTelecaller) {
      dispatch(fetchAllocationUsersWise(cleanParams));
    } else if (isCases && !isTelecaller) {
      if (selectedTab === "Allocated" && !isTelecaller) {
        dispatch(
          fetchAllocatedCase({
            ...cleanParams,
            ...query,
          }),
        );
      } else if (selectedTab === "Unallocated") {
        dispatch(fetchUnAllocatedCase(cleanParams));
      }
    } else if (isTelecaller) {
      dispatch(
        fetchTelecallerAllocatedCase({
          ...cleanParams,
          ...query,
        }),
      );
    }
  }, [
    params,
    selectedTab,
    isUserWise,
    isCases,
    user,
    dispatch,
    refresh,
    // query,
    JSON.stringify(query),
    isReady,
  ]);
  useEffect(() => {
    if (!location.state?.preserveFilters) {
      dispatch(clearQuery());
    }
    setIsReady(true);
    dispatch(fetchUserFilters());
    dispatch(fetchBankDashboard());
    dispatch(fetchTelecallerBankDashboard());
  }, [dispatch, location.state]);

  const handlePagination = (page, page_size) => {
    setParams((prev) => ({ ...prev, page, page_size }));
  };

  /* Sorting is server-side: the column key becomes an `ordering` query
     param, prefixed with "-" for descending, and the list goes back to
     page one because the whole result set is re-ordered. */
  const handleSortChange = ({ field, order }) => {
    setParams((prev) => {
      const next = { ...prev, page: 1 };
      if (!field || !order) {
        delete next.ordering;
      } else {
        next.ordering = order === "ascend" ? field : `-${field}`;
      }
      return next;
    });
  };

  const getCases = () => {
    if (getUserType(user) === "telecaller") {
      return telecaller_cases?.data?.results?.allocated_cases;
    } else {
      return allocated_case?.data?.results?.allocated_cases;
    }
  };

  const getCount = () => {
    if (getUserType(user) === "telecaller") {
      return telecaller_cases?.data?.count;
    } else {
      return allocated_case?.data?.count;
    }
  };
  console.log(query, "lksdjfkldslkfdslkfj");
  return (
    <div className="allocationPage">
      <Flex justify="space-between" align="center" className="allocationHeader">
        <Flex className="headerLeft">
          {isUserWise && (
            <Input
              placeholder="Search"
              allowClear
              className="searchInput"
              prefix={<SearchICon />}
              onChange={(e) => setSearchInput(e.target.value)}
              onPressEnter={(e) => {
                const value = e.target.value;
                setParams((prev) => ({
                  ...prev,
                  search: value,
                  page: 1,
                  page_size: 10,
                }));
              }}
            />
          )}

          {isCases && getUserType(user) !== "telecaller" && (
            <Tabs
              options={tabOptions}
              active={selectedTab}
              onChange={(tab) => {
                setSelectedTab(tab);
                setSelectedPortfolio("all");
                setPortfolioResetKey((prev) => prev + 1);
                setIsAll(false);
                setSelectedIds([]);
              }}
              selectorBreakpoint={300}
            />
          )}
          {isCases && (
            <Input
              placeholder="Search"
              allowClear
              className="searchInput"
              prefix={<SearchICon />}
              onChange={(e) => setSearchInput(e.target.value)}
              onPressEnter={(e) => {
                const value = e.target.value;
                setParams((prev) => ({
                  ...prev,
                  search: value,
                  page: 1,
                  page_size: 10,
                }));
              }}
            />
          )}
        </Flex>

        <Flex
          className="all-buttons"
          gap={15}
          justify="space-between"
          align="center"
        >
          {isUserWise && (
            <CustomFilterDropdown
              buttonLabel="Filter"
              options={filters}
              onChange={(val) => {
                setParams((prev) => ({
                  ...prev,
                  role: val,
                  page: 1,
                  page_size: 10,
                }));
              }}
            />
          )}
          {isCases && selectedTab === "Allocated" && (
            <Button
              className="exportButton"
              onClick={() => setExportModalOpen(true)}
            >
              Export
            </Button>
          )}
          {isCases && selectedTab === "Allocated" && (
            <AllocationFilter
            // setPrimaryItems={setPrimaryItems}
            // setSecondaryItems={setSecondaryItems}
            // secondaryItems={secondaryItems}
            // primaryItems={primaryItems}
            // fetchData={fetchMainData}
            // fetchData2={fetchSecondaryData}
            // fetchData3={fetchExtraData}
            />
          )}
          <CustomFilterDropdown
            buttonLabel="Portfolio"
            key={portfolioResetKey}
            options={
              getUserType(user) === "telecaller" ? telePortfolios : portfolios
            }
            value={selectedPortfolio}
            onChange={(val) => {
              setParams((prev) => ({
                ...prev,
                portfolio: val,
                page: 1,
                page_size: 10,
              }));
              dispatch(setQuery({ portfolio: val }));
            }}
          />
          {(selectedTab === "Unallocated" ||
            (selectedTab === "Allocated" && selectedIds.length > 0)) && (
              <Button onClick={handleAllocate} className="allocateButton">
                Allocate
              </Button>
            )}
        </Flex>
      </Flex>

      <Flex className="allocationContent">
        {isUserWise && (
          <UserWiseList
            data={user_wise_list}
            onRowClick={handleClick}
            pointer={true}
            loading={user_wise_loading}
            portfolio={params?.portfolio}
            handlePaginationChange={(page, page_size) => {
              dispatch(
                fetchAllocationUsersWise({
                  page: page,
                  page_size: page_size,
                }),
              );
            }}
          />
        )}

        {isCases && (
          <AllCases
            selectedTab={selectedTab}
            onSelectionChange={setSelectedIds}
            onRowClick={handleRowClick}
            pointer={true}
            unAllocatedCasesData={
              unAllocated_case?.data?.results?.unallocated_cases
            }
            allocatedCasesData={getCases()}
            allocatedCount={getCount()}
            unAllocatedCount={unAllocated_case?.data?.count}
            onPaginationChange={handlePagination}
            setRefresh={setRefresh}
            setIsAll={setIsAll}
            isAll={isAll}
            onSortChange={handleSortChange}
          />
        )}
      </Flex>
      <AllocateModal
        open={allocateModalOpen}
        portfolio={params?.portfolio}
        onClose={() => {
          setAllocateModalOpen(false);
          setIsAll(false);
          // setSelectedIds([]);
        }}
        selectedIds={selectedIds}
        setRefresh={setRefresh}
        isAll={isAll}
        activeTab={selectedTab}
      />
      <ExportModal 
        open={exportModalOpen}
        onClose={() => setExportModalOpen(false)}
      />
    </div>
  );
};

export default AllocationPage;
